import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useWriteParamsToUrl(
  stringifiedData: Record<string, string>,
  replace?: boolean,
  enabled = true
) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const newParams = new URLSearchParams(
      replace
        ? stringifiedData
        : {
            ...Object.fromEntries(searchParams),
            ...stringifiedData,
          }
    );
    setSearchParams(newParams, {
      replace: true,
    });
  }, [stringifiedData, setSearchParams, searchParams, replace, enabled]);
}
